import React, {useState} from 'react';
import {ServiceData} from './ServiceData';
import {useDispatch, useSelector} from 'react-redux';
import {updateServiceAccessForm} from '../IdfSaleSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

function Service(props) {
  const dispatch = useDispatch();
  const serviceAccessForm = useSelector((state) => state.idfSale.serviceAccessForm);
  const [selectedServices, setSelectedServices] = useState(serviceAccessForm);

  const handleServiceSelection = (serviceId, value) => {
    setSelectedServices((prevSelected) => ({
      ...prevSelected,
      [serviceId]: value,
    }));
  };

  const handleServiceUpdate = () => {
    dispatch(updateServiceAccessForm(selectedServices));
    props.setIsShowPopUp(false);
  };

  return (
    <div className='services'>
      {ServiceData.map((section, sectionIndex) => (
        <div
          key={sectionIndex}
          className={`section-container ${sectionIndex === 0 ? 'first' : ''} ${sectionIndex === 3 ? 'section3' : ''}`}>
          <div className='sub-container'>
            <div className='title-container'>
              <div className='section-title'>{`${sectionIndex + 1}. ${section.title}`}</div>
              {sectionIndex === 0 && (
                <div className='open-close-title'>
                  <span>חסום</span>
                  <span>פתוח</span>
                </div>
              )}
            </div>
            <div key={sectionIndex} className='service-container'>
              {sectionIndex === 3 && (
                <div className='radio-buttons'>
                  <label>
                    <input
                      type='radio'
                      value='false'
                      checked={selectedServices[section.id] === false}
                      onChange={() => handleServiceSelection(section.id, false)}
                    />
                  </label>
                  <label>
                    <input
                      type='radio'
                      value='true'
                      checked={selectedServices[section.id] === true}
                      onChange={() => handleServiceSelection(section.id, true)}
                    />
                  </label>
                </div>
              )}
            </div>
          </div>

          {section.services.map((service, serviceIndex) => (
            <div key={serviceIndex} className='service-container'>
              <div className='text-container'>
                {service.key != null ? <span>{service.key + '.' + ' '}</span> : ''}
                {service.id != null ? <span>{service.value}</span> : <li>{service.value}</li>}
              </div>
              {service.id != null && (
                <div className='radio-buttons'>
                  <label>
                    <input
                      type='radio'
                      value='false'
                      checked={selectedServices[service.id] === false}
                      onChange={() => handleServiceSelection(service.id, false)}
                    />
                  </label>
                  <label>
                    <input
                      type='radio'
                      value='true'
                      checked={selectedServices[service.id] === true}
                      onChange={() => handleServiceSelection(service.id, true)}
                    />
                  </label>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
      <div className='mt-4'>
        <BtnSubmit isBusiness text='אישור וחזרה לתהליך' onclick={() => handleServiceUpdate()} />
      </div>
    </div>
  );
}

export default Service;
